import React from "react";
import loadable from "@loadable/component";
import PropTypes from "prop-types";
import parse from "html-react-parser";
const Glider = loadable(() => import("react-glider"));
import "glider-js/glider.min.css";
import styled from "styled-components";
import { HiddenOnDesktop, HiddenOnPhone } from "./hidden.js";
import SwipeContainer from "./swipecontainer.js";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: var(--color-secondary);
  max-width: 100%;
  width: 100%;
  padding: 2rem;
  font-family: var(--font-paragraphs);

  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    padding: 1rem;
  }

  .glider {
    scrollbar-width: none;
  }

  .glider-track {
    gap: 1.5rem;
    margin: 0 auto;
  }
  .glider-prev,
  .glider-next {
    top: 40%;
    &.disabled {
      display: none;
    }
  }
`;
const WrapperTitle = styled.h2`
  text-align: center;
  margin-bottom: 3rem;
  font-size: 2rem;
  font-weight: 400;
  color: var(--color-body-text);
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1.5rem;
    margin: 1rem 0 0 0;
    padding: 20px 15px 15px 15px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    text-align: left;
  }
`;
const Quote = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  text-align: center;
  color: var(--color-body-text);
  font-weight: 100;
  padding: 3rem;
  background-color: var(--color-body);
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    padding: 15px;
    text-align: left;
  }
`;

const Title = styled.p`
  color: var(--color-body-text);
  font-weight: bold;
  margin-bottom: 10px;
`;
const Text = styled.div`
  &:before {
    content: "«";
  }
  &:after {
    content: "»";
  }
`;
const Author = styled.p`
  font-style: italic;
  margin-top: 10px;
`;

const Quotes = ({ title, quotes }) => {
  return (
    <Wrapper>
      <WrapperTitle>{title}</WrapperTitle>
      <HiddenOnPhone style={{ maxWidth: "100%" }}>
        <Glider swipable hasArrows slidesToScroll={2} slidesToShow={2}>
          {quotes.map((item, i) => (
            <Quote key={i}>
              <Title>{item.title}</Title>
              <Text>{parse(item.quote)}</Text>
              <Author>{item.author}</Author>
            </Quote>
          ))}
        </Glider>
      </HiddenOnPhone>
      <HiddenOnDesktop>
        <SwipeContainer>
          {quotes.map((item, i) => (
            <Quote key={i}>
              <Title>{item.title}</Title>
              <Text>{parse(item.quote)}</Text>
              <Author>{item.author}</Author>
            </Quote>
          ))}
        </SwipeContainer>
      </HiddenOnDesktop>
    </Wrapper>
  );
};

export default Quotes;

Quotes.propTypes = {
  title: PropTypes.string,
  quotes: PropTypes.array,
};

Quotes.defaultProps = {
  title: "Kundetilbakemeldinger",
  quotes: [],
};
